<template>
	<div
		class="modal size-guide-popup-container"
		v-bind:class="{ active: this.$root.store === true }"
		id="coupon-modal"
		v-if="this.$root.store"
		@click="close_store_popup()"
	>
		<div class="modal-dialog" style="max-width: 530px">
			<div class="modal-content">
				<div class="modal-body">
					<!-- class="close" -->
					<button
						type="button"
						class="close popupClose"
						@click="close_store_popup()" 
					>
						&times;
					</button>
					<div class="moreStores" v-if="this.$root.storesData.stores">
						<h3>Choose {{ this.$root.storesData.name }} Outlet</h3>
						<div>
							{{ this.$root.storesData.stores.length }} outlets near you
						</div>
						<router-link
							:to="{ path: '/store.html', query: { store: store.id } }"
							v-for="(store, i) in this.$root.storesData.stores"
							:key="i"
						>
							<div class="stores">
								<div>
									<p>{{ store.address }}</p>
								</div>
								<div>
									<p class="storeRating">
										<i class="fa fa-star" aria-hidden="true"></i>
										{{ store.ratings.avg_rating }}
									</p>
								</div>
								<div>
									<p class="storeDistance">
										<span>{{ store.distance }}</span> Km away
									</p>
								</div>
							</div>
						</router-link>
					</div>
					    
					<!-- <Login /> -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		methods: {
			close_store_popup() {
				this.$root.store = false;
			},
		},
	};
</script>
<style>
	.moreStores {
		padding: 10px;
	}
	.moreStores a {
		color: var(--font-dark-blue);
		font-size: 14px;
		line-height: 24px;
		font-family: 'lhmRegular';
	}
	.modal-content {
		/* border-radius: 0px !important; */
	}
	.stores {
		/* padding-bottom: 10px; */
		margin: 10px 0px;
	}
	.moreLinks .router-link-active {
		color: #626262 !important;
	}
	.moreStores > h3 {
		font-size: 24px;
		line-height: 30px;
		color: #626262;
		font-family: 'lhmSemiBold';
		text-align: left;
		margin: 0px;
	}
	.moreStores > div {
		text-align: left;
		font-size: 14px;
		line-height: 24px;
		color: #626262;
		font-family: 'lhmRegular';
	}
	.stores {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		border-bottom: 0.5px solid #a2a2a2;
		box-sizing: border-box;
		cursor: pointer;
		align-items: baseline;
	}
	.moreStores a:last-child div {
		border-bottom: none;
	}
	.stores p {
		margin: 0px;
		font-family: 'lhmSemiBold';
		font-size: 14px;
		line-height: 24px;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.fa-star {
		color: #FFD700 !important;
	}
	.stores > div {
		width: 40%;
		text-align: left;
		padding: 5px;
	}
	.stores > div:nth-child(2) {
		width: 20%;
		text-align: left;
		padding: 5px;
	}
	.stores > div:nth-child(3) {
		width: 40%;
		text-align: right;
		padding: 5px;
		font-size: 12px;
		line-height: 15px;
	}
	.storeRating {
		font-size: 12px !important;
		line-height: 15px !important;
		font-family: 'lhmRegular' !important;
		padding-left: 50%;
	}

	.storeDistance span {
		font-family: 'lhmSemiBold' !important;
		font-size: 12px !important;
		line-height: 15px !important;
	}
	.storeDistance {
		font-size: 12px !important;
		line-height: 15px !important;
		font-family: 'lhmRegular' !important;
		color: #626262;
	}
	.moreStores.storeDrop a {
		color: #626262;
	}
</style>